import { checklistStatusTypes } from 'constants/checklist'

import * as types from '../actionTypes/Checklist'

const initialState = {
    status: checklistStatusTypes.IN_PROGRESS,
    step: null,
    error: null,
}

const ChecklistReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_CHECKLIST_STATE:
            return {
                ...state,
                status: action.payload,
            }

        case types.SET_CHECKLIST_STEP:
            return {
                ...state,
                step: action.payload,
            }

        case types.SET_CHECKLIST_ERROR:
            return {
                ...state,
                error: action.payload,
            }

        default:
            return state
    }
}

export default ChecklistReducer
